import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DatapassService } from './datapass.service';
import { AlertController, LoadingController } from '@ionic/angular';
import { WsAPiService } from 'src/app/ws-api.service';
import { LoadingService } from 'src/app/loading.service';
import { EventEmitter } from 'events';
import { EOrderStatus, IOrder } from 'src/app/model.service';
import { FbmessagingService } from 'src/app/fbmessaging.service';
import { Subscription } from 'rxjs/internal/Subscription';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  loginStatus = { time: new Date() };
  pingStatus = { time: new Date() };
  public static emmiter = new EventEmitter();
  public static subs = Array<number>();

  public static order_list = {
    new: [],
    cancel: [],
    completed: []
  };

  constructor(public http: HttpClient,

    public dataPassService: DatapassService,
    public loadingservice: LoadingService,
    public load: LoadingController,
    public wsApi: WsAPiService,
    public alrt: AlertController) {

    let ic = 1
    if (!ApiService.subs.includes(ic)) {
      this.wsApi.pingSubscription.subscribe(r => {
        console.log('PING', r);
        this.pingStatus.time = new Date();

      })
      ApiService.subs.push(ic++);
    }


    if (!ApiService.subs.includes(ic)){
       this.wsApi.loginSubscription.subscribe(r => {
        console.log('LOGIN', r);
        this.loginStatus.time = new Date();
      })
      ApiService.subs.push(ic++);
    }
     
    if (!ApiService.subs.includes(ic)){
       this.wsApi.storeacceptedSubscription.subscribe(r => {
        console.log('neworder', r);
        if (!r) return;

        if (r.orderStatus == EOrderStatus.delivered) {

          this.loadingservice.ontoast('ໄລເດີ້ມາສົ່ງສິນຄ້າແລ້ວ', 3000);

          const index = ApiService.order_list['new'].findIndex(v => v?.uuid == r?.uuid);

          console.log(index);
          console.log(ApiService.order_list['new']);
          
          if (index != -1) {
            console.log('fffff',r?.uuid);
            
            ApiService.order_list['new'][index] = r

            console.log(ApiService.order_list['new'][index]);
            
          }

        } else if (r.orderStatus == EOrderStatus.completed) {

          this.loadingservice.ontoast('ຮ້ານກົດຢືນຢັນວ່າທ່ານໄດ້ຮັບສິນຄ້າແລ້ວ', 3000);

          const index = ApiService.order_list['new'].findIndex(v => v?.uuid == r?.uuid);
          if (index != -1) {
            ApiService.order_list['new'].splice(index, 1);
            ApiService.order_list['completed'].push(r);
          }

        } else if (r.orderStatus == EOrderStatus.cancel) {

          this.loadingservice.ontoast('ຮ້ານຍົກເລີກອໍເດີ້ແລ້ວ', 2000);

          this.playsound('cancelorder');

          const index = ApiService.order_list['new'].findIndex(v => v?.uuid == r?.uuid);
          if (index != -1) {
            ApiService.order_list['new'].splice(index, 1);
            ApiService.order_list['cancel'].push(r);
          }
        }
        else {

          this.loadingservice.ontoast('ຮ້ານຕອບກັບອໍເດີ້ຂອງທ່ານແລ້ວ', 3000);

          const index = ApiService.order_list['new'].findIndex(v => v?.uuid == r?.uuid);
          if (index != -1) {
            ApiService.order_list['new'][index] = r;
          }
        }

        if(r.orderStatus != EOrderStatus.cancel){
          this.playsound('beep');
        }

        if (this.dataPassService.currentpage == '') {
          this.dataPassService.dot = true;
          return;
        }
        console.log('Eventes ',ApiService.emmiter.eventNames());
        
        if (ApiService.emmiter.eventNames().find(v => v == 'storeAccepted')) {
          ApiService.emmiter.emit('storeAccepted', r)
        }

      })
      ApiService.subs.push(ic++);
    }
     

  }

  playsound(sound:string) {
    var mp3 = new Audio('../../assets/'+sound+'.mp3');
    mp3.play();
    console.log("play mp3");
  }

  onStoreAccepted(cb: (o: IOrder) => void) {
    ApiService.emmiter.on('storeAccepted', cb);
    console.log('EMITTER', ApiService.emmiter.eventNames());
  }

  loginWS(token: string) {
    this.wsApi.loginWS(token);
  }

  protected getBaseUrl_orderbilding(): string {

    return environment.server_orderbilling;
    //  return 'http://localhost:21000/api/v1/';

  }
  protected getBaseUrl_inventory(): string {

    return environment.server_inventory;
    //  return 'http://localhost:24000/api/v1/';

  }
  protected getBaseUrl(): string {

    //  return 'http://localhost:22000/api/v1/';
    return environment.server;

  }
  protected getBaseUrl_auth(): string {

    return environment.server_usermanager;
    //  return 'http://localhost:4500/';
    //  return 'http://laotracking.com:4500/';

  }
  protected getBaseUrl_vdp(): string {

    //  return 'http://192.168.1.122:8080/inventory-management/sign-in';
    // return 'http://localhost:9599/inventory/';

    //  return 'http://laotracking.com:23000/';
    // return location.protocol + '//' + location.host+'/api/';
    environment.production = true;
    console.log(environment.production);
    const url = !environment.production ? location.protocol + '//' + location.host + '/api/' : environment.vdpserver;
    return url;


  }

  protected getFileManagerUrl(): string {

    //  return 'http://localhost:22000/api/v1/';
    return environment.serverFile;

  }

  protected headerBase(): any {
    const token = localStorage.getItem('token');
    let skip = localStorage.getItem('skip')
    let skip_store = localStorage.getItem('skip_store')
    let skip_tag = localStorage.getItem('skip_tag')

    if (skip == null) {
      skip = '0'
    }
    if (skip_tag == null) {
      skip_tag = '0'
    }
    if (skip_store == null) {
      skip_store = '0'
    }

    // const authorization='dba123456';
    // .set('authorization',authorization+'');

    const myheader = new HttpHeaders({ 'Content-Type': 'application/json' }).set('Access-Control-Allow-Origin', '*')
      .set('token', token + '').set('skip', skip + '').set('skip_store', skip_store + '').set('skip_tag', skip_tag + '');
    return myheader;
  }

  async alert(text: string) {
    const alert = await this.alrt.create({
      header: 'ແຈ້ງເຕືອນ',
      message: text,
      backdropDismiss: false,
      buttons: ['OK']
    });

    await alert.present();
  }


  getImage(img: string) {
    return this.getFileManagerUrl() + 'file/download/' + img
  }
}
